import { t } from "i18next";
import { useState } from "react";

import { SortOrder, SortProperty } from "#modules/quoteRequests/view/useQuoteRequestLinesSorting";
import { Icon } from "#shared/icons/Icon";
import { ActionIcon } from "#shared/view/components/ActionIcon";
import { Flex } from "#shared/view/components/Flex";
import { Select } from "#shared/view/designSystem/Select";

type Props = {
  orderQuoteRequestLines: (property: SortProperty, order?: SortOrder) => void;
};

type SortOption = {
  label: string;
  value: SortProperty;
};

const SORT_OPTIONS: SortOption[] = [
  { label: t("quoteRequestLine.sort.byIndex"), value: "index" },
  { label: t("quoteRequestLine.sort.byName"), value: "name" },
  { label: t("quoteRequestLine.sort.byDate"), value: "createdAt" },
];

export const SortSection = ({ orderQuoteRequestLines }: Props) => {
  const [sortOption, setSortOption] = useState<SortOption["value"]>("index");

  const [sortOrder, setSortOrder] = useState<SortOrder>("asc");

  const handleSortOptionChange = (option: SortOption["value"]) => {
    setSortOption(option);
    orderQuoteRequestLines(option, sortOrder);
  };

  const toggleSortOrder = () => {
    setSortOrder(sortOrder === "asc" ? "desc" : "asc");
    orderQuoteRequestLines(sortOption, sortOrder === "asc" ? "desc" : "asc");
  };

  return (
    <Flex gap="xxs" align="center" justify={"flex-end"}>
      <Select
        value={sortOption}
        size="xs"
        data={SORT_OPTIONS}
        variant="filled"
        onChange={(value) => handleSortOptionChange(value as SortOption["value"])}
        styles={{ root: { maxWidth: 150 } }}
      />

      <ActionIcon variant={"light"} size="xs" onClick={toggleSortOrder}>
        <Icon name={sortOrder === "desc" ? "orderingDesc" : "orderingAsc"} size={12} />
      </ActionIcon>
    </Flex>
  );
};
